<template>
    <el-dialog :visible.sync="visible" :title="'修改考试信息'" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="学期名" prop="termName">
                <el-input v-model="currentTerm.termName" placeholder="学期名" disabled></el-input>
            </el-form-item>
            <el-form-item label="考试标题" prop="examName">
                <el-input v-model="dataForm.examName" placeholder="考试标题"></el-input>
            </el-form-item>
            <el-form-item label="考试类型" prop="examType">
                <el-select v-model="dataForm.examType" placeholder="考试类型" clearable>
                    <el-option v-for="examTypeList in examType" :label="examTypeList.name" :value="examTypeList.id"
                               :key="examTypeList.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { examType } from '@/constant'

export default {
  data () {
    return {
      visible: false,
      examClassConfigVisible: false,
      currentTerm: '',
      examType,
      grades: [],
      multipleTable: [],
      dataForm: {
        id: '',
        termId: '',
        termName: '',
        examName: '',
        examType: '',
        createDate: '',
        updateDate: '',
        creator: '',
        deptId: '',
        deptName: '',
        gradeIds: '',
        schoolId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        examName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        examType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        rankDistId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    selectionChange (val) {
      this.multipleTable = val
    },
    // 获取信息
    getInfo () {
      this.$http.get('/exam/exam/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    dataListSelectionChangeHandle (list) {
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/exam/exam/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
              console.log('关闭')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false }),
    // 获取信息
    getCurrentTerm () {
      this.$http.get('/term/term/getCurrentTerm').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.currentTerm = res.data
        this.dataForm.termId = res.data.id
        this.dataForm.termName = res.data.termName
        this.dataForm.schoolId = res.data.schoolId
      }).catch(() => {})
    }
  },
  components: {
  },
  mounted () {
    this.getCurrentTerm()
    this.getGradeList()
  }
}
</script>
